import { getJson } from './client';
import type { SocForecastResponse } from './types';
export const fetchSocForecast = () => getJson<SocForecastResponse>('/api/soc-forecast');
